export const headerContent = `<style>
    @font-face {
        font-weight: 300;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-light.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 400;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-regular.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 500;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-medium.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: bold;
        font-family: Aeonik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/aeonik-bold.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 300;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-light-italic.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: normal;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-regular-italic.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: 500;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-medium-italic.woff2") format("woff2");
        font-display: swap;
    }
    @font-face {
        font-weight: bold;
        font-family: Aeonik;
        font-style: italic;
        src: url("https://s.c.dk/fonts/aeonik-bold-italic.woff2") format("woff2");
        font-display: swap;
    }
</style>
<style>
    .nd-header .link {
        cursor: pointer;
        font-weight: inherit;
        text-decoration-line: none;
        background: transparent;
        border: none;
    }
    .nd-header .link:hover {
        text-decoration-line: underline;
    }
    .nd-header .link._primary {
        color: #0f140a;
        text-decoration-color: #0f140a;
    }
    .nd-header .link._secondary {
        color: var(--primary-text-color, #000000cc);
        text-decoration-color: var(--primary-text-color, #000000cc);
    }
    .nd-header .link._legal-info {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
        font-weight: 500;
        color: #0000008f;
        text-decoration-color: #0000008f;
    }
    .nd-header .link._underline-on-hover {
        text-decoration-line: none;
    }
    .nd-header .link._underline-on-hover:hover {
        text-decoration-line: underline;
    }
    .nd-header .link._underline-on-mouse-leave {
        text-decoration-line: underline;
    }
    .nd-header .link._underline-on-mouse-leave:hover {
        text-decoration-line: none;
    }
    .nd-header .link._underline-none {
        text-decoration-line: none;
    }
    .nd-header .link._underline-none:hover {
        text-decoration-line: none;
    }
    .nd-header .link._underline-always {
        text-decoration-line: underline;
    }
    .nd-header .link._underline-always:hover {
        text-decoration-line: underline;
    }
    .nd-header .link._large {
        font-size: var(--font-large-font-size, 1.125rem);
        line-height: var(--font-large-line-height, 1.1112);
    }
    .nd-header .link._medium {
        font-size: var(--font-big-font-size, 1rem);
        line-height: var(--font-big-line-height, 1.125);
    }
    .nd-header .link._small {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
    }
    .nd-header .link._extra-small {
        font-size: var(--font-small-font-size, 0.75rem);
        line-height: var(--font-small-line-height, 1.1667);
    }
    .nd-header .link._bold {
        font-weight: var(--bold-font-weight, 500);
    }
    .nd-header .link._primary-colored {
        color: var(--primary-color, #00dc00);
    }

</style>
<style>
    .button {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        font-weight: 500;
        line-height: normal;
        text-align: center;
        letter-spacing: 0.2px;
        white-space: nowrap;
        border-radius: 24px;
    }

    .button span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
    }

    .button._icon-right {
        flex-direction: row-reverse;
    }

    .button._icon-right svg {
        margin-left: 5px;
    }

    .button._icon-left svg:not(:last-child) {
        margin-right: 5px;
    }

    .button._large {
        font-size: var(--font-big-font-size, 1rem);
        line-height: var(--font-big-line-height, 1.125);
        min-width: 88px;
        height: 32px;
        padding: 10px 16px;
    }

    .button._small {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
        min-width: 72px;
        height: 28px;
        padding: 10px 16px;
        font-weight: 500;
    }

    .button._full-width {
        width: 100%;
    }

    .button._left-aligned-text {
        justify-content: flex-start;
    }

    .button._primary {
        color: var(--primary-text-color, #000000cc);
        background: var(--primary-color, #00dc00);
        border: none;
    }

    .button._primary:hover {
        background: var(--primary-hover-color, #00ff00);
    }

    .button._primary:active {
        background: #00c200;
    }

    .button._primary._advantageCard {
        align-self: center;
        width: fit-content;
        font-size: 16px;
        font-weight: 400;
    }

    .button._secondary {
        color: #ffffffde;
        background: #323232;
        border: none;
    }

    .button._secondary:hover {
        background: #464646;
    }

    .button._secondary:active {
        background: #515151;
    }

    .button._outlined {
        color: var(--primary-text-color, #000000cc);
        background-color: transparent;
        border: 2px var(--primary-text-color, #000000cc) solid;
    }

    .button._outlined:hover {
        background-color: #4637000f;
        background-blend-mode: multiply;
    }

    .button._outlined:active {
        background-color: #4637001f;
        background-blend-mode: multiply;
    }

    .button._outlined._advantageCard {
        align-self: center;
        width: fit-content;
        font-size: 16px;
        font-weight: 400;
    }

    .button._disabled {
        pointer-events: none;
        cursor: auto;
        color: #00000061;
        background: #0000001e;
        border: none;
    }

    .button._loading {
        pointer-events: none;
        cursor: auto;
    }

    .button:focus-visible {
        outline: 2px dashed var(--primary-text-color, #000000cc);
        outline-offset: 2px;
    }

    .button._onlyIcon {
        min-width: 32px;
        height: 32px;
        padding: 0;
    }
</style>
<style>
    :root {
        --nd-header-transition-time: 0.3s;
    }
    .nd-header * {
        box-sizing: border-box;
    }
    .nd-header ul,
    .nd-header ol,
    .nd-header dl {
        margin: 0;
        padding: 0;
    }
    .auth__avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        aspect-ratio: 1 / 1;
        width: 24px;

        font-size: 0.8125rem;
        color: #fff;

        background-color: #191919;
        border-radius: 50%;
    }
    .auth__avatar._primary {
        width: 40px;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
    }

    .auth-popup {
        display: none;
        position: absolute;
        top: 68px;
        right: 250px;
        background: #FFFFFF;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16), 0 4px 12px rgba(0, 0, 0, 0.16);
        border-radius: 0 0 8px 8px;

        color: rgba(0, 0, 0, 0.87);
        min-width: 368px;
        cursor: default;
    }
    .auth-popup__wrapper {
        padding: 32px;
    }
    .auth-popup._opened {
        display: block;
    }

    .auth-popup__title {
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
    }

    .auth-popup__name {
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;

        text-decoration-line: underline;
        color: rgba(0, 0, 0, 0.87);
    }

    .auth-popup__private-information {
        display: flex;
        gap: 16px;
        align-items: center;
        padding-block: 16px;
    }

    .auth-popup__button {
        margin-top: 16px;
        width: 82px;
        height: 40px;
        background: #1FAB2E;
        border-radius: 48px;
        border: none;
        letter-spacing: 0.2px;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #FFFFFF;
        cursor: pointer;
    }

    .auth__auth-button[hidden] {
        display: none;
    }

    .nd-header {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    .nd-header {
        font-family: Aeonik, sans-serif;
        letter-spacing: 0.15px;
    }

    .nd-header a {
        text-decoration: none;
    }

    .nd-header button {
        font-family: inherit;
    }

    .nd-header {
        position: fixed;
        z-index: 100;
        top: 0;
        right: 0;
        left: 0;
        background: #fff;
        font-family: "Aeonik", sans-serif;
        font-size: 1rem;
        font-weight: 400;
        font-style: normal;
        font-feature-settings: "tnum";
        -webkit-font-smoothing: antialiased;
        transition: top var(--nd-header-transition-time);
    }

    .nd-header ._mobile {
        display: none;
    }

    body._hiddenHeaderTop .nd-header {
        top: calc(0px - var(--nd-header-top-height));
    }

    body._hiddenHeaderTop #Coi-Renew {
        z-index: 1;
    }

    .nd-header__top {
        display: flex;
        align-items: center;
        height: 40px;
        color: #fff;
        background: #F0F0F0;
    }

    .nd-header__top-inner {
        width: 1200px;
    }

    .nd-header .page-limiter {
        max-width: 1200px;
        margin: 0 auto;
    }

    .nd-header__top-controls {
        display: flex;
        gap: 24px;
        align-items: center;
        justify-content: end;
        font-size: 10px;
        line-height: 16px;
    }

    .nd-header__top-control {
        cursor: pointer;
        user-select: none;
        display: flex;
        gap: 9px;
        align-items: center;
    }

    .nd-header__top-control-link {
        display: flex;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #000000;
        text-decoration: none;
        align-items: center;
        letter-spacing: 0.15px;
    }

    .nd-header__top-control-image {
        margin-right: 8px;
    }

    .nd-header__middle {
        position: relative;
        display: flex;
        height: 68px;
        background: #fff;
    }

    .nd-header__middle-inner {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: space-between;
    }

    .nd-header__left {
        display: flex;
    }

    .nd-header__go-back {
        display: none;
    }

    .nd-header__logo {
        display: flex;
        margin-right: 64px;
    }

    .nd-header__logo-image {
        max-height: 52px;
    }

    .nd-header__logo-link {
        display: flex;
        align-items: center;
    }

    .nd-header__links {
        display: flex;
        gap: 32px;
        padding-inline-start: 0;
    }

    .nd-header__link {
        cursor: pointer;
        display: flex;
        align-items: start;
        align-self: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.87);
        white-space: nowrap;
        border-bottom: #ffffff 2px solid;
        text-decoration: none;
    }

    .nd-header__link:hover {
        border-bottom: #1fab2e 2px solid;
    }

    .nd-header__controls {
        display: grid;
        grid-auto-flow: column;
        gap: 16px;
        align-items: center;
        justify-content: end;
    }

    .nd-header__controls._mobile {
        justify-content: start;
    }

    .nd-header__control {
        cursor: pointer;
        user-select: none;
    }

    .nd-header__control-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .search__container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .search__icon {
        fill: rgba(0, 0, 0, 0.87);
    }

    .nd-header__control._search {
        position: relative;
    }

    .nd-header__search {
        position: absolute;
        width: 100%;
        top: 10px;

        display: none;
    }

    .search__field {
        position: relative;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 8px 6px 20px;
        border: 2px solid #1FAB2E;
        border-radius: 60px;
        background: #fff;

        transition: 0.4s;
        transform: translateX(1000px);
        opacity: 0;
    }

    .search__field._opened {
        transform: translateX(0);
        opacity: 1;
    }

    .search__field-container-inner {
        margin: 0px 71px 0 136px;
    }

    .search__field-components {
        position: relative;
        overflow: hidden;
    }

    .search__field-icon {
        width: 32px;
        height: 32px;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 0;
        background: #fff;
        outline: none;
        border: none;
        cursor: pointer;
    }

    .search__field-icon:focus-visible svg {
        outline: 2px auto rgba(0, 0, 0, 0.87);
    }

    .search__field-icon._search {
        position: absolute;
        top: 8px;
        right: 5px;
        cursor: default;
        border-radius: 16px;

        display: none;
    }

    .search__field-icon-separator {
        width: 1px;
        height: 24px;
        margin-right: 35px;

        background-color: rgba(0, 0, 0, 0.23);
    }

    .search__icon {
        fill: rgba(0, 0, 0, 0.87);
    }

    .search__input {
        width: 100%;
        padding: 0;

        font-family: "Aeonik", sans-serif;
        color: rgba(0, 0, 0, 0.87);
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.5px;

        outline: none;
        border: none;
    }

    .search__input::placeholder {
        color: rgba(0, 0, 0, 0.87);
    }

    .search__label {
        flex-grow: 1;
    }

    .search__suggestions-container {
        position: relative;
        width: 100%;
    }

    .search__suggestions {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        background-color: #FFF;
        padding: 58px 0 12px;
        border-radius: 24px;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.24), 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
        overflow: hidden;
    }

    .search__suggestions:empty {
        padding: 0;
    }

    .search__suggestion {
        display: block;
        padding: 6px 16px;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        cursor: pointer;
    }

    .search__suggestion,
    .search__suggestion:active,
    .search__suggestion:visited {
        color: #000000de;
    }

    .search__suggestion:focus,
    .search__suggestion:focus-visible,
    .search__suggestion:hover {
        font-weight: 500;
        background: #1D9D2A;
        color: #fff;
    }

    .cart-min__cart-min {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .auth__auth-button {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .cart-min__desktop {
        display: block;
        background-color: transparent;
        border: none;
        padding: 0;
    }

    .nd-header__go-back._hidden {
        display: none;
    }

    .nd-header__title {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
    }

    .nd-header__title._hidden {
        display: none;
    }

    .nd-header__controls._web-view {
        display: flex;
    }

    @media screen and (min-width: 1025px) and (max-width: 1309px) {
        .nd-header .page-limiter {
            margin: 0 48px;
        }

        .nd-header+.bg {
            display: block;
        }
    }

    @media screen and (max-width: 1024px) {
        .nd-header ._desktop {
            display: none;
        }

        .nd-header ._mobile {
            display: flex;
            gap: 16px;
        }

        .nd-header+.bg {
            display: block;
            margin-top: 68px;
        }

        .nd-header__top {
            display: none;
        }

        .nd-header__top-controls {
            display: none;
        }

        .nd-header__middle {
            height: 68px;
        }

        .nd-header__middle .page-limiter {
            padding-inline: 24px 20px;
        }

        .nd-header__logo {
            display: flex;
            flex: 1 1 auto;
            justify-content: center;
        }

        .nd-header__links {
            display: grid;
            grid-auto-flow: column;
            grid-column-gap: 48px;
            margin: 0 50px;
        }

        .nd-header__controls {
            flex: 1 1 0;
            gap: 14px;
        }

        ._mobile-first {
            grid-column: 1;
        }

        ._mobile-second {
            grid-column: 2;
        }
        ._mobile-second._hidden {
            display: none;
        }
    }

    @media screen and (max-width: 767px) {
        .auth-popup {
            width: 100%;
            box-shadow: none;
            border-radius: unset;
        }
        .auth-popup__wrapper {
            width: 100%;
            box-shadow: none;
            padding: 24px;
            height: calc(100vh - var(--nd-total-header-height));
        }
        .auth-popup__title {
            font-size: 16px;
            line-height: 24px;
        }

        .auth-popup__name {
            font-size: 16px;
            line-height: 24px;
        }

        .auth-popup__button {
            margin-top: 40px;
        }
        .nd-header__logo._hideInWebView {
            display: none;
        }

        .nd-header__go-back {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-color: transparent;
            border: none;
            cursor: pointer;
        }
    }

    @media screen and (max-width: 375px) {
        .auth-popup {
            top: 50px;
        }
        .nd-header__middle {
            height: 50px;
        }

        .nd-header+.bg {
            margin-top: 50px;
        }
    }
</style>
<style>
    .nav-menu__item-wrapper {
        text-decoration: none;
        display: flex;
        align-items: start;
        align-self: center;
        white-space: nowrap;
    }
    .nav-menu__item {
        border-bottom: #ffffff 2px solid;
    }
    ._hover .nav-menu__item,
    ._leaving .nav-menu__item {
        border-bottom: #1fab2e 2px solid;
    }
    .nav-menu__item-container {
        position: absolute;
        top: 68px;
        left: 0;
        right: 0;
        background: #FFFFFF;
        min-height: 300px;
        visibility: hidden;
        padding: 32px;
        overflow: auto;
        display: block;
        max-height: calc(100vh - 108px);
        scrollbar-gutter: stable both-edges;
    }
    .nav-menu__item-wrapper._hover .nav-menu__item-container,
    .nav-menu__item-wrapper._leaving .nav-menu__item-container{
        visibility: visible;
    }
    .nav-menu__label {
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        color: rgba(0, 0, 0, 0.87);
        white-space: nowrap;
        text-decoration: none;
        background-color: transparent;
        border: 0;
    }
    .nav-menu__item-inner {
        display: flex;
        gap: 24px;
        justify-content: space-between;
    }
    .nav-menu__groups-section {
        display: flex;
        gap: 24px;
        flex-wrap: wrap;
    }
    .nav-menu__group {
        width: 220px;
        white-space: initial;
    }
    .nav-menu__group-title {
        font-family: 'Aeonik', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #A2A2A2;
        padding: 0 0 16px 0;
    }
    .nav-menu__links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        gap: 8px;
    }
    .nav-menu__link-wrapper {
        display: block;
    }
    .nav-menu__link {
        letter-spacing: 0.3px;
    }

    .nav-menu__shortcuts-section {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
        min-width: 130px;
        color: pink;
        list-style-type: none;
    }
    .nav-menu__shortcut-wrapper {
        display: flex;
        text-align: right;
        margin-bottom: 16px;
    }
    .nav-menu__shortcut {
        justify-content: flex-end;
        flex-direction: row;
        gap: 6px;
        margin-left: 4px;
    }

    @media screen and (min-width:1025px) and (max-width:1309px) {
        .nav-menu__item-inner.page-limiter {
            margin: 0;
        }
    }
</style>
<script>
    function debounce(func, timeout = 300) {
        let timer;

        return function(...args) {
            if (timer) {
                clearTimeout(timer);
            }

            timer = setTimeout(function() {
                func.apply(this, args);
            }, timeout);
        };
    }
</script>

<header class="nd-header">
        <div class="nd-header__top">
            <div class="nd-header__top-inner page-limiter">
                <div class="nd-header__top-controls">
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://musik.yousee.dk" >
                                YouSee Musik
                            </a>
                        </div>
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://play.yousee.dk" >
                                YouSee Play
                            </a>
                        </div>
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://profil.yousee.dk/?context=mail" >
                                Webmail
                            </a>
                        </div>
                        <div class="nd-header__top-control">
                            <a class="nd-header__top-control-link" href="https://yousee.dk/hjaelp/kontakt" >
                                Kontakt os
                            </a>
                        </div>
                </div>
            </div>
        </div>
    <div class="nd-header__middle jsMiddleMenu">
        <div class="nd-header__middle-inner page-limiter">
            <div class="nd-header__left">
                    <div class="nd-header__logo">
                        <a
                            class="nd-header__logo-link jsNavLogoLink"
                            href="https://yousee.dk"
                        >
                            <img
                                class="nd-header__logo-image _full"
                                src="https://yousee.dk/shop/images/nuuday/yousee-logo.svg"
                                width="91"
                                height="26"
                                alt="YouSee"
                            />
                        </a>
                    </div>
                    <ul class="nd-header__links _desktop nav-menu">
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Mobil</button>
            <div class="nav-menu__item-container">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobiltelefoner</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner"

>
                                                        Alle mobiltelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner/tilbud"

>
                                                        Tilbud på mobiltelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner/apple"

>
                                                        Se de nyeste iPhones

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner/samsung"

>
                                                        Se de nyeste fra Samsung

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobilabonnementer</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                                                        Alle mobilabonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                                        Smartwatch abonnement

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/5g"

>
                                                        Danmarks bedste mobilnet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"

>
                                                        Roaming

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/musik"

>
                                                        YouSee Musik

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/mobiltilvalg"

>
                                                        Ring til udlandet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"

>
                                                        Datapakker

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tilbehør</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoeretelefoner"

>
                                                        Høretelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoejttalere"

>
                                                        Højttalere

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets"

>
                                                        Tablets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/watches"

>
                                                        SmartWatches

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/covers"

>
                                                        Covers

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=screen protection"

>
                                                        Skærmbeskyttelse

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=charges and cables"

>
                                                        Oplader &amp; kabler

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"

>
                                                        Dækningskort

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Driftsinformation

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/5g"

>
                                                        5G

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/byt-mobil"

>
                                                        Bytterabat

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://kampagne.yousee.dk/3g"

>
                                                        Farvel til 3G

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tilbudsavis"

>
                                                        Tilbudsavis

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
    class="button _outlined _small _icon-right nav-menu__shortcut"
    style=""
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/mobil"
        target="_blank"
    
>
                                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.278 4.123 1.978.23a.927.927 0 0 0-1.225 0 .76.76 0 0 0 0 1.134l3.7 3.325-3.7 3.325a.767.767 0 0 0 0 1.133.898.898 0 0 0 1.217 0l4.308-3.892a.767.767 0 0 0 0-1.133Z" fill="#000" fill-opacity=".87"/></svg>
                                            
                                        Hjælp til mobil

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Internet</button>
            <div class="nav-menu__item-container">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Internet til hjemmet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/bredbaand#forside"

>
                                                        Se internet-abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/fibernet"

>
                                                        Få fiber fra YouSee

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/internet"

>
                                                        Hvilken hastighed skal jeg vælge?

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/mesh"

>
                                                        Stabilt internet i hele hjemmet

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobilt Internet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet"

>
                                                        Se mobilt internet-abonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet/Mobilt-Internet-1TB-5G?modem=none"

>
                                                        5G-internet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"

>
                                                        Se dækningskort

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                                                        Hastighedstest

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://mustsee.yousee.dk/internet"

>
                                                        Tips til dit internet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Driftsinformation

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/flytadresse"
target="_blank"
>
                                                        Flyt adresse

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tilbudsavis"

>
                                                        Tilbudsavis

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
    class="button _outlined _small _icon-right nav-menu__shortcut"
    style=""
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/internet"
        target="_blank"
    
>
                                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.278 4.123 1.978.23a.927.927 0 0 0-1.225 0 .76.76 0 0 0 0 1.134l3.7 3.325-3.7 3.325a.767.767 0 0 0 0 1.133.898.898 0 0 0 1.217 0l4.308-3.892a.767.767 0 0 0 0-1.133Z" fill="#000" fill-opacity=".87"/></svg>
                                            
                                        Hjælp til internet

</a>
                                </li>
                                <li class="nav-menu__shortcut-wrapper">



<a
    class="button _outlined _small _icon-right nav-menu__shortcut"
    style=""
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/mobilt-internet"
        target="_blank"
    
>
                                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.278 4.123 1.978.23a.927.927 0 0 0-1.225 0 .76.76 0 0 0 0 1.134l3.7 3.325-3.7 3.325a.767.767 0 0 0 0 1.133.898.898 0 0 0 1.217 0l4.308-3.892a.767.767 0 0 0 0-1.133Z" fill="#000" fill-opacity=".87"/></svg>
                                            
                                        Hjælp til Mobilt Internet

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Tv &amp; streaming</button>
            <div class="nav-menu__item-container">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tv-abonnementer</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/play"

>
                                                        YouSee Play

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/nye-kanaler"

>
                                                        8 nye tv-kanaler

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tv-pakker"

>
                                                        Faste tv-pakker

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/foreninger"

>
                                                        Foreningsaftaler

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/play#kanaloverblik"

>
                                                        Se alle tv-kanaler

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Streaming</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/play#kanaloverblik"

>
                                                        Se alle streamingtjenester

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/netflix"

>
                                                        Netflix

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tv2play"

>
                                                        TV 2 Play

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/viaplay"

>
                                                        Viaplay

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/disneyplus"

>
                                                        Disney+

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/max"

>
                                                        Max

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">TIlbehør</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tv-boksen"

>
                                                        Tv-boks

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/streamer"

>
                                                        Streamer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/play-appen"

>
                                                        App - altid inkluderet

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/premiere"

>
                                                        YouSee Premiere

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://play.yousee.dk/tv-guide"

>
                                                        Tv-guide

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/sport"

>
                                                        Sport i tv

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/premier-league"

>
                                                        Ugens Premier League-kampe

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
    class="button _outlined _small _icon-right nav-menu__shortcut"
    style=""
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "
        target="_blank"
    
>
                                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.278 4.123 1.978.23a.927.927 0 0 0-1.225 0 .76.76 0 0 0 0 1.134l3.7 3.325-3.7 3.325a.767.767 0 0 0 0 1.133.898.898 0 0 0 1.217 0l4.308-3.892a.767.767 0 0 0 0-1.133Z" fill="#000" fill-opacity=".87"/></svg>
                                            
                                        Hjælp til tv &amp; streaming

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Ure &amp; tablets</button>
            <div class="nav-menu__item-container">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Find ure &amp; tablets</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets"

>
                                                        Alle tablets

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/watches"

>
                                                        Alle smartwatches

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets-og-smartwatch?label=tilbud"

>
                                                        Se aktuelle tilbud

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets-og-smartwatch?brand=apple"

>
                                                        Apple

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tablets-og-smartwatch?brand=samsung"

>
                                                        Samsung

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Abonnement til ur eller tablet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                                        Smartwatch abonnement

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                                                        Alle mobilabonnementer

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/mobilt-internet"

>
                                                        Mobilt Internet-abonnementer

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"

>
                                                        Se dækningskort

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/5g"

>
                                                        Danmarks bedste mobilnetværk

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Driftsinformation

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/5g"

>
                                                        5G

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tilbudsavis"

>
                                                        Tilbudsavis

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
    class="button _outlined _small _icon-right nav-menu__shortcut"
    style=""
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"
        target="_blank"
    
>
                                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.278 4.123 1.978.23a.927.927 0 0 0-1.225 0 .76.76 0 0 0 0 1.134l3.7 3.325-3.7 3.325a.767.767 0 0 0 0 1.133.898.898 0 0 0 1.217 0l4.308-3.892a.767.767 0 0 0 0-1.133Z" fill="#000" fill-opacity=".87"/></svg>
                                            
                                        Hjælp til SmartWatch

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <button class="nav-menu__label jsNavMenuLabel">Tilbehør</button>
            <div class="nav-menu__item-container">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Find tilbehør</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer"

>
                                                        Alt tilbehør

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer/tilbud"

>
                                                        Tilbud på tilbehør

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=premium accessories"

>
                                                        Tilbehør med mobilabonnement

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=bluetooth headset"

>
                                                        Hovedtelefoner

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/hoejttalere"

>
                                                        Højttalere

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mobiltelefon tilbehør</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/covers"

>
                                                        Covers

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=screen protection"

>
                                                        Skærmbeskyttelse

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=charges and cables"

>
                                                        Opladere og kabler

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer?category=wallets"

>
                                                        Wallets

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Tips &amp; inspiration</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://musik.yousee.dk"

>
                                                        YouSee Musik

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                                                        Smartwatch-abonnement

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/tilbudsavis"

>
                                                        Tilbudsavis

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                </div>
            </div>
    </div>
</li>
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <a href="https://yousee.dk/hjaelp" class="nav-menu__label jsNavMenuLabel">Hjælp</a>
            <div class="nav-menu__item-container">
                <div class="nav-menu__item-inner page-limiter">
                        <div class="nav-menu__groups-section">
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Mest læste artikler</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/mit-internet-virker-ikke"

>
                                                        Mit internet virker ikke

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/sadan-skifter-du-betalingskort"

>
                                                        Sådan skifter du betalingskort

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"

>
                                                        Tag mobilen med på rejsen

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/sadan-ser-du-tv-og-film-pa-app-og-web"

>
                                                        Sådan ser du tv og film med YouSee Play

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/artikler/tilknyt-din-yousee-mail-til-mit-yousee-login"

>
                                                        Tilknyt din YouSee Mail til Mit YouSee-login

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Produkter</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/tv-og-streaming"

>
                                                        Tv &amp; Streaming

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/internet"

>
                                                        Internet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/mail"

>
                                                        Mail

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/mobil"

>
                                                        Mobil

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/mobilt-internet"

>
                                                        Mobilt Internet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/fastnet"

>
                                                        Fastnet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/yousee-musik"

>
                                                        YouSee Musik

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Regninger</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/regning-og-betaling"

>
                                                        Regning &amp; betaling

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/login-og-mit-yousee"

>
                                                        Login &amp; Mit YouSee

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/sikkerhed-pa-nettet"

>
                                                        Sikkerhed på nettet

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement"

>
                                                        Vilkår &amp; abonnement

</a>
                                                </li>
                                        </ul>
                                    </div>
                                    <div class="nav-menu__group">
                                        <div class="nav-menu__group-title">Andet</div>
                                        <ul class="nav-menu__links">
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                                        Tjek driftsinformation

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                                                        Tjek hastighedstest

</a>
                                                </li>
                                                <li class="nav-menu__link-wrapper">


<a
class="link _secondary _small _underline-on-hover nav-menu__link jsNavMenuLink"

tabindex="0"
href="https://yousee.dk/hjaelp/butik"

>
                                                        Find YouSee Butik

</a>
                                                </li>
                                        </ul>
                                    </div>
                        </div>
                        <ul class="nav-menu__shortcuts-section">
                                <li class="nav-menu__shortcut-wrapper">



<a
    class="button _outlined _small _icon-right nav-menu__shortcut"
    style=""
    
    
    tabindex="0"
    href="https://yousee.dk/hjaelp"
        target="_blank"
    
>
                                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.278 4.123 1.978.23a.927.927 0 0 0-1.225 0 .76.76 0 0 0 0 1.134l3.7 3.325-3.7 3.325a.767.767 0 0 0 0 1.133.898.898 0 0 0 1.217 0l4.308-3.892a.767.767 0 0 0 0-1.133Z" fill="#000" fill-opacity=".87"/></svg>
                                            
                                        Find mere hjælp

</a>
                                </li>
                        </ul>
                </div>
            </div>
    </div>
</li>
<li class="nav-menu__item-wrapper jsNavMenuItem">
    <div class="nav-menu__item">
            <a href="https://selvbetjening.yousee.dk" class="nav-menu__label jsNavMenuLabel">Mit YouSee</a>
    </div>
</li>
                    </ul>
            </div>
                <div class="nd-header__right">
                    <div class="nd-header__controls ">
                            <div class="nd-header__control _desktop">
                                <button type="button" class="search__container jsSearchOpen" title="Søg" role="button">
                                    <svg class="search__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m19.695 18.307-4.11-4.1a6.953 6.953 0 0 0 1.41-4.19 7.01 7.01 0 0 0-7.01-7c-3.87 0-7 3.13-7 7a6.995 6.995 0 0 0 11.18 5.61l4.11 4.1a.996.996 0 1 0 1.41-1.41l.01-.01Zm-9.71-3.45c-2.68 0-4.85-2.17-4.85-4.85a4.84 4.84 0 0 1 4.85-4.84c2.68 0 4.85 2.17 4.85 4.85 0 2.68-2.17 4.85-4.85 4.85v-.01Z"/></svg>
                                </button>
                            </div>
                        <div class="nd-header__control _mobile-second " data-component="MinCartContainer">
                            <div class="cart-min__desktop">
                                    <a href="https://yousee.dk/shop/kurv" class="cart-min__cart-min" title="Gå til kurv">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 6a3 3 0 1 1 6 0v1H9V6ZM7 9v1a1 1 0 1 0 2 0V9h6v1a1 1 0 1 0 2 0V9h3v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h3Zm0-2V6a5 5 0 0 1 10 0v1h5v10a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7h5Z" fill="#000" fill-opacity=".87"/></svg>
                                    </a>
                                <div class="popoverCartMinContainer"></div>
                            </div>
                        </div>
                        <div class="nd-header__control taAuthIcon jsAuthIcon _mobile-first" data-component="AuthContainer">
                            <div class="auth__authContainer">
                                    <section class="auth-popup jsPopup">
                                        <div class="auth-popup__wrapper">
                                            <h2 class="auth-popup__title">Du er logget ind</h2>
                                            <div class="auth-popup__private-information jsPrivateInformation">
                                                <div class="auth__avatar _primary jsAvatar">
                                                    
                                                </div>
                                                <u class="auth-popup__name">
                                                    <span class="auth-popup__firstName jsFirstName"></span>
                                                    <span class="auth-popup__lastName jsLastName"></span>
                                                </u>
                                            </div>
                                            <button class="auth-popup__button jsLogOutButton" type="button"
                                                    title="Log ud"
                                                    role="button">Log ud</button>
                                        </div>
                                    </section>
                                <button type="button"
                                        class="auth__auth-button jsUserButton"
                                        hidden
                                        title="Log ind" role="button">
                                    <div class="auth__popover-anchor"></div>
                                    <div
                                        class="auth__avatar jsAvatar">
                                    </div>
                                </button>
                                <button type="button"
                                        
                                        class="auth__auth-button jsLogInButton"
                                        
                                        title="Log ind" role="button">
                                    <div class="auth__popover-anchor"></div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M11.904 2.6C8.672 2.6 6 5.151 6 8.36c0 3.21 2.672 5.76 5.904 5.76 3.232 0 5.904-2.55 5.904-5.76 0-3.209-2.672-5.76-5.904-5.76ZM8 8.36C8 6.311 9.72 4.6 11.904 4.6s3.904 1.711 3.904 3.76c0 2.049-1.72 3.76-3.904 3.76S8 10.41 8 8.36ZM12 15c-2.273 0-4.469.316-6.132 1.214-.845.456-1.572 1.073-2.086 1.89C3.266 18.928 3 19.898 3 21a1 1 0 1 0 2 0c0-.772.182-1.364.476-1.831.295-.472.74-.87 1.342-1.195C8.051 17.309 9.854 17 12 17c2.146 0 3.95.309 5.182.974.603.325 1.047.723 1.343 1.195.293.467.475 1.06.475 1.831a1 1 0 1 0 2 0c0-1.103-.266-2.073-.782-2.895-.514-.818-1.241-1.435-2.086-1.891C16.469 15.316 14.272 15 12 15Z"
                                              fill="#000" fill-opacity=".87"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="nd-header__control _mobile">
<style>
    .header__middle[data-active-level="1"] .go-back-to-1,
    .header__middle[data-active-level="2"] .go-back-to-2 {
        display: flex;
    }

    .header__control-button,
    .mobile-menu__go-back,
    .ecare-mobile-menu__go-back{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }

    .mobile-menu__go-back,
    .header__control-button._hidden {
        display: none;
    }

    ._active-nav-menu .header__left,
    ._active-nav-menu ._mobile-second,
    ._active-nav-menu ._mobile-first {
        display: none;
    }

    ._active-nav-menu  .header__controls {
        display: flex;
    }

    ._active-nav-menu  .header__right {
        flex-grow: 1;
    }

    ._active-nav-menu ._mobile {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
    }

    .mobile-menu__popover {
        position: fixed;
        top: 68px;
        left: 0;
        right: 0;
        background-color: #fff;
        height: calc(100% - 68px);
        flex-direction: column;
        justify-content: space-between;
        overflow: auto;
        display: none;
        visibility: hidden;
        opacity: 0;
    }

    @media screen and (max-width:375px) {
        .mobile-menu__popover {
            top: 50px;
            height: calc(100% - 50px);
        }
    }

    .mobile-menu__popover._visible {
        display: flex;
        visibility: visible;
        opacity: 1;
        transition: 200ms ease-out opacity;
        z-index: 10;
    }

    .mobile-menu__inner {
        padding-inline: 24px;
    }

    .mobile-menu-search {
        margin: 16px 0;
        width: 100%;
        background-color: #FFF;
        border-radius: 24px;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.24), 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
        overflow: hidden;
        flex-direction: column;
    }

    .mobile-menu-search._empty {
        box-shadow: none;
    }

    .mobile-menu-search__field {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0 8px 0 20px;
        height: 48px;
        border: 1px solid rgba(0, 0, 0, 0.23);
        border-radius: 60px;
    }

    .mobile-menu-search__suggestions {
        margin: 8px 0 12px;
    }

    ._active-search .mobile-menu-search__field {
        border: 2px solid #1FAB2E;
    }

    .mobile-menu-search__suggestions:empty {
      margin: 0;
    }


    .mobile-menu-search__suggestion:last-child {
      margin-bottom: 12px;
    }

    .mobile-menu__nav-menu._hidden {
        display: none;
    }

    .mobile-menu__ecare-nav-menu._hidden {
        display: none;
    }

    ._active-search .mobile-menu__nav-menu,
    ._active-search .header__bottom-links{
        display: none;
    }

    .mobile-menu-search__input {
        border: none;
        display: flex;
        flex-grow: 1;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        align-items: center;
        letter-spacing: 0.5px;
        color: rgba(0, 0, 0, 0.87);
    }

    .mobile-menu-search__input:focus-visible {
        outline: none;
    }

    .mobile-menu-search__close-container {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .mobile-menu-search._empty .mobile-menu-search__close-container {
        opacity: 0;
    }

    .mobile-menu-search__separator {
        display: block;
        margin-right: 4px;
        width: 1px;
        height: 24px;
        background-color: rgba(0, 0, 0, 0.23);
    }

    button.mobile-menu-search__button {
        background: none;
        border: none;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button.mobile-menu-search__button._cross {
        cursor: pointer;
    }

    .mobile-menu-search__input::placeholder,
    .mobile-menu-search__input:-ms-input-placeholder,
    .mobile-menu-search__input::-ms-input-placeholder{
        color: rgba(0, 0, 0, 0.87);
        opacity: 1; /* Firefox */
    }

    .list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 20px;
        padding: 20px 0;
        list-style: none;
    }

    .mobile-menu__label {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: none;
        border: 0;
        width: 100%;
        cursor: pointer;
        padding: 0;
    }

    .mobile-menu__links-group {
        display: none;
    }

    .list-item._active {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        padding: 16px 24px;
    }

    .list-item._active > .mobile-menu__label {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: rgba(0, 0, 0, 0.87);
        margin-bottom: 8px;
        letter-spacing: 0.15px;
    }

    .list-item._active > .mobile-menu__label .mobile-menu__label_arrow {
        display: none;
    }

    .list-item._active > .mobile-menu__label .mobile-menu__nav-link{
        font-weight: 700;
        font-size: 18px;
        cursor: default;
        pointer-events: none;
    }

    .list-item._active > .list {
        display: flex;
        padding: 16px 0;
        cursor: pointer;
    }

    .list-item .header__shortcuts {
        display: none;
    }

    .list-item._active > .header__shortcuts {
        display: flex;
        margin-top: auto;
        flex-direction: row;
        justify-content: flex-start;
        gap: 16px;
        flex-wrap: wrap;
    }

    .header__shortcut {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: rgba(0, 0, 0, 0.87);
        gap: 6px;
        border: 2px solid rgba(0, 0, 0, 0.87);
        border-radius: 24px;
        padding: 6px 20px;
        justify-content: center;
    }

    .mobile-menu__links {
        display: none;
    }

    .mobile-menu__link,
    .mobile-menu__nav-link {
        color: rgba(0, 0, 0, 0.87);
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.15px;
        text-decoration-line: none;
    }

    .mobile-menu__link {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;
    }

    .header__bottom-links {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 24px;
        padding-top: 16px;
        padding-bottom: 16px;
        scrollbar-width: none;
        overflow-x: auto;
        flex-flow: row nowrap;
    }

    .header__bottom-links ::-webkit-scrollbar {
        display: none;
    }

    .header__bottom-link {
        display: flex;
        gap: 16px;
        align-items: center;
        color: rgba(0, 0, 0, 0.87);
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.2px;
        white-space: nowrap;
        flex-direction: column;
    }

    .header__bottom-link:first-of-type {
        margin-left: 24px;
    }

    .header__bottom-link:last-of-type {
        margin-right: 24px;
    }

    .header__bottom-link-icon-container {
        margin: 0;
        padding-inline: 4px;
    }

    .cart-min__cart-min._hidden {
        display: none;
    }
</style>
<button type="button" class="mobile-menu__go-back go-back-to-1 jsMenuButtonBack" title="Tilbage" role="button">
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53561 14.9311C8.14489 15.3214 7.51173 15.3211 7.1214 14.9304L0.939959 8.74272C0.755107 8.57439 0.633605 8.33769 0.615418 8.0726C0.595629 7.79366 0.692301 7.508 0.905434 7.29466L7.1214 1.07243C7.51173 0.681714 8.14489 0.681395 8.53562 1.07172C8.92634 1.46205 8.92665 2.09522 8.53633 2.48594L4.02366 7.00314L18.5019 7.00315C19.0542 7.00315 19.5019 7.45086 19.5019 8.00315C19.5019 8.55543 19.0542 9.00315 18.5019 9.00315L4.02713 9.00314L8.53633 13.5169C8.92665 13.9076 8.92633 14.5408 8.53561 14.9311Z" fill="black" fill-opacity="0.87"/>
    </svg>
</button>
<button type="button" class="mobile-menu__go-back go-back-to-2 jsMenuButtonBack" title="Tilbage" role="button">
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53561 14.9311C8.14489 15.3214 7.51173 15.3211 7.1214 14.9304L0.939959 8.74272C0.755107 8.57439 0.633605 8.33769 0.615418 8.0726C0.595629 7.79366 0.692301 7.508 0.905434 7.29466L7.1214 1.07243C7.51173 0.681714 8.14489 0.681395 8.53562 1.07172C8.92634 1.46205 8.92665 2.09522 8.53633 2.48594L4.02366 7.00314L18.5019 7.00315C19.0542 7.00315 19.5019 7.45086 19.5019 8.00315C19.5019 8.55543 19.0542 9.00315 18.5019 9.00315L4.02713 9.00314L8.53633 13.5169C8.92665 13.9076 8.92633 14.5408 8.53561 14.9311Z" fill="black" fill-opacity="0.87"/>
    </svg>
</button>
    <button type="button" class="header__control-button jsMenuButtonOpen" title="Menu" role="button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.2 7.2h9.6m-9.6 9.6h9.6M4.8 12h14.4" stroke="#000" stroke-opacity=".87" stroke-width="2" stroke-linecap="round"/>
        </svg>
    </button>
<button type="button" class="ecare-mobile-menu__go-back" id="jsEcareNavMenuButtonBack" title="Tilbage" role="button" style="display: none;">
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53561 14.9311C8.14489 15.3214 7.51173 15.3211 7.1214 14.9304L0.939959 8.74272C0.755107 8.57439 0.633605 8.33769 0.615418 8.0726C0.595629 7.79366 0.692301 7.508 0.905434 7.29466L7.1214 1.07243C7.51173 0.681714 8.14489 0.681395 8.53562 1.07172C8.92634 1.46205 8.92665 2.09522 8.53633 2.48594L4.02366 7.00314L18.5019 7.00315C19.0542 7.00315 19.5019 7.45086 19.5019 8.00315C19.5019 8.55543 19.0542 9.00315 18.5019 9.00315L4.02713 9.00314L8.53633 13.5169C8.92665 13.9076 8.92633 14.5408 8.53561 14.9311Z" fill="black" fill-opacity="0.87"/>
    </svg>
</button>
<button type="button" class="header__control-button jsMenuButtonClose _hidden" title="Luk" role="button" id="jsMenuButtonClose">
    <svg width="24" height="24" viewBox="-4 -4 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41055 8.00494L14.9605 2.46494C15.3505 2.07494 15.3505 1.44494 14.9605 1.05494C14.5705 0.664941 13.9405 0.664941 13.5505 1.05494L8.00055 6.59494L2.46055 1.04494C2.07055 0.654941 1.43055 0.654941 1.04055 1.04494C0.650547 1.43494 0.650547 2.07494 1.04055 2.46494L6.59055 8.00494L1.04055 13.5449C0.650547 13.9349 0.650547 14.5649 1.04055 14.9549C1.43055 15.3449 2.06055 15.3449 2.45055 14.9549L7.99055 9.41494L13.5305 14.9549C13.9205 15.3449 14.5505 15.3449 14.9405 14.9549C15.3305 14.5649 15.3305 13.9349 14.9405 13.5449L9.40055 8.00494H9.41055Z" fill="black" fill-opacity="0.87"/>
    </svg>
</button>
<div class="mobile-menu__popover jsMobileMenuPopover">
    <div class="mobile-menu__inner">
            <div class="mobile-menu-search _empty jsMobileMenuSearch">
                <div class="mobile-menu-search__field">
                    <input class="mobile-menu-search__input jsMobileMenuSearchInput" type="text" placeholder="Søg">
                    <span class="mobile-menu-search__close-container _empty jsMobileSearchCloseContainer">
                        <button type="button"
                            class="mobile-menu-search__button _cross jsMobileSearchClose"
                            role="button"
                        >
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.675 10.0042L16.3 5.38753C16.625 5.06253 16.625 4.53753 16.3 4.21253C15.975 3.88753 15.45 3.88753 15.125 4.21253L10.5 8.8292L5.88338 4.2042C5.55838 3.8792 5.02505 3.8792 4.70005 4.2042C4.37505 4.5292 4.37505 5.06253 4.70005 5.38753L9.32505 10.0042L4.70005 14.6209C4.37505 14.9459 4.37505 15.4709 4.70005 15.7959C5.02505 16.1209 5.55005 16.1209 5.87505 15.7959L10.4917 11.1792L15.1084 15.7959C15.4334 16.1209 15.9584 16.1209 16.2834 15.7959C16.6084 15.4709 16.6084 14.9459 16.2834 14.6209L11.6667 10.0042H11.675Z" fill="black" fill-opacity="0.6"/>
                            </svg>
                        </button>
                        <span class="mobile-menu-search__separator"></span>
                    </span>
                    <button type="button" class="mobile-menu-search__button" title="Søg" role="button">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6954 15.3071L13.5854 11.2071C14.4654 10.0371 14.9954 8.58709 14.9954 7.01709C14.9854 3.14709 11.8554 0.0170898 7.98535 0.0170898C4.11535 0.0170898 0.985352 3.14709 0.985352 7.01709C0.985352 10.8871 4.11535 14.0171 7.98535 14.0171C9.55535 14.0171 10.9954 13.4971 12.1654 12.6271L16.2754 16.7271C16.6654 17.1171 17.2954 17.1171 17.6854 16.7271C18.0754 16.3371 18.0754 15.7071 17.6854 15.3171L17.6954 15.3071ZM7.98535 11.8571C5.30535 11.8571 3.13535 9.68709 3.13535 7.00709C3.13535 4.32709 5.30535 2.16709 7.98535 2.16709C10.6654 2.16709 12.8354 4.33709 12.8354 7.01709C12.8354 9.69709 10.6654 11.8671 7.98535 11.8671V11.8571Z" fill="black" fill-opacity="0.6"/>
                        </svg>
                    </button>
                </div>
                <div class="mobile-menu-search__suggestions jsSearchMobileSuggestions"></div>
            </div>


        <nav class="mobile-menu">
                <ul class="mobile-menu__nav-menu jsNavMenu list" data-level="1">

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Mobil</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobiltelefoner</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner"  >
                                            Alle mobiltelefoner
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner/tilbud"  >
                                            Tilbud på mobiltelefoner
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner/apple"  >
                                            Se de nyeste iPhones
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobiltelefoner/samsung"  >
                                            Se de nyeste fra Samsung
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobilabonnementer</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilabonnement"  >
                                            Alle mobilabonnementer
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/smartwatch"  >
                                            Smartwatch abonnement
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/5g"  >
                                            Danmarks bedste mobilnet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"  >
                                            Roaming
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/musik"  >
                                            YouSee Musik
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/mobiltilvalg"  >
                                            Ring til udlandet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"  >
                                            Datapakker
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tilbehør</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoeretelefoner"  >
                                            Høretelefoner
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoejttalere"  >
                                            Højttalere
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets"  >
                                            Tablets
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/watches"  >
                                            SmartWatches
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/covers"  >
                                            Covers
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=screen protection"  >
                                            Skærmbeskyttelse
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=charges and cables"  >
                                            Oplader &amp; kabler
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"  >
                                            Dækningskort
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Driftsinformation
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/5g"  >
                                            5G
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/byt-mobil"  >
                                            Bytterabat
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://kampagne.yousee.dk/3g"  >
                                            Farvel til 3G
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tilbudsavis"  >
                                            Tilbudsavis
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til mobil</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/kategori/mobil"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til mobil</span>
                                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                </svg>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Internet</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Internet til hjemmet</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/bredbaand#forside"  >
                                            Se internet-abonnementer
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/fibernet"  >
                                            Få fiber fra YouSee
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/internet"  >
                                            Hvilken hastighed skal jeg vælge?
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/mesh"  >
                                            Stabilt internet i hele hjemmet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til Mobilt Internet</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobilt Internet</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilt-internet"  >
                                            Se mobilt internet-abonnementer
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilt-internet/Mobilt-Internet-1TB-5G?modem=none"  >
                                            5G-internet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"  >
                                            Se dækningskort
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til Mobilt Internet</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/hastighedstest"  >
                                            Hastighedstest
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://mustsee.yousee.dk/internet"  >
                                            Tips til dit internet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Driftsinformation
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/flytadresse"   target="_blank" >
                                            Flyt adresse
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tilbudsavis"  >
                                            Tilbudsavis
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til internet</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                    <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til Mobilt Internet</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/kategori/internet"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til internet</span>
                                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                </svg>
                            </a>
                            <a href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til Mobilt Internet</span>
                                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                </svg>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Tv &amp; streaming</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tv-abonnementer</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/play"  >
                                            YouSee Play
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/nye-kanaler"  >
                                            8 nye tv-kanaler
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tv-pakker"  >
                                            Faste tv-pakker
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/foreninger"  >
                                            Foreningsaftaler
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/play#kanaloverblik"  >
                                            Se alle tv-kanaler
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Streaming</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/play#kanaloverblik"  >
                                            Se alle streamingtjenester
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/netflix"  >
                                            Netflix
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tv2play"  >
                                            TV 2 Play
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/viaplay"  >
                                            Viaplay
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/disneyplus"  >
                                            Disney+
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/max"  >
                                            Max
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">TIlbehør</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tv-boksen"  >
                                            Tv-boks
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/streamer"  >
                                            Streamer
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/play-appen"  >
                                            App - altid inkluderet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/premiere"  >
                                            YouSee Premiere
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://play.yousee.dk/tv-guide"  >
                                            Tv-guide
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/sport"  >
                                            Sport i tv
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/premier-league"  >
                                            Ugens Premier League-kampe
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/kategori/tv-og-streaming?icid=nav_right_h_tv "  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til tv &amp; streaming</span>
                                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                </svg>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Ure &amp; tablets</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Find ure &amp; tablets</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets"  >
                                            Alle tablets
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/watches"  >
                                            Alle smartwatches
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets-og-smartwatch?label=tilbud"  >
                                            Se aktuelle tilbud
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets-og-smartwatch?brand=apple"  >
                                            Apple
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tablets-og-smartwatch?brand=samsung"  >
                                            Samsung
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til SmartWatch</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Abonnement til ur eller tablet</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/smartwatch"  >
                                            Smartwatch abonnement
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilabonnement"  >
                                            Alle mobilabonnementer
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/mobilt-internet"  >
                                            Mobilt Internet-abonnementer
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til SmartWatch</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation/mobilt-bredbaand/daekningskort"  >
                                            Se dækningskort
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/5g"  >
                                            Danmarks bedste mobilnetværk
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Driftsinformation
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/5g"  >
                                            5G
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tilbudsavis"  >
                                            Tilbudsavis
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                        <span class="header__shortcut-name">Hjælp til SmartWatch</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp/artikler/hjaelp-til-smartwatch-abonnement"  class="header__shortcut">
                                <span class="header__shortcut-name">Hjælp til SmartWatch</span>
                                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                </svg>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Tilbehør</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Find tilbehør</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer"  >
                                            Alt tilbehør
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer/tilbud"  >
                                            Tilbud på tilbehør
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=premium accessories"  >
                                            Tilbehør med mobilabonnement
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=bluetooth headset"  >
                                            Hovedtelefoner
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/hoejttalere"  >
                                            Højttalere
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mobiltelefon tilbehør</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/covers"  >
                                            Covers
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=screen protection"  >
                                            Skærmbeskyttelse
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=charges and cables"  >
                                            Opladere og kabler
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/shop/tilbehoer?category=wallets"  >
                                            Wallets
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Tips &amp; inspiration</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://musik.yousee.dk"  >
                                            YouSee Musik
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/smartwatch"  >
                                            Smartwatch-abonnement
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/tilbudsavis"  >
                                            Tilbudsavis
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>

                            </li>
                        </ul>


                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <button class="mobile-menu__label jsMenuButtonNav" role="button">
                            <span class="mobile-menu__nav-link">Hjælp</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </button>

                        <ul class="mobile-menu__links-group list" data-level="2">
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Mest læste artikler</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/mit-internet-virker-ikke"  >
                                            Mit internet virker ikke
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/sadan-skifter-du-betalingskort"  >
                                            Sådan skifter du betalingskort
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tag-mobilen-med-pa-rejsen"  >
                                            Tag mobilen med på rejsen
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/sadan-ser-du-tv-og-film-pa-app-og-web"  >
                                            Sådan ser du tv og film med YouSee Play
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/artikler/tilknyt-din-yousee-mail-til-mit-yousee-login"  >
                                            Tilknyt din YouSee Mail til Mit YouSee-login
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Produkter</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/tv-og-streaming"  >
                                            Tv &amp; Streaming
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/internet"  >
                                            Internet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/mail"  >
                                            Mail
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/mobil"  >
                                            Mobil
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/mobilt-internet"  >
                                            Mobilt Internet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/fastnet"  >
                                            Fastnet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/yousee-musik"  >
                                            YouSee Musik
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Regninger</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/regning-og-betaling"  >
                                            Regning &amp; betaling
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/login-og-mit-yousee"  >
                                            Login &amp; Mit YouSee
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/sikkerhed-pa-nettet"  >
                                            Sikkerhed på nettet
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement"  >
                                            Vilkår &amp; abonnement
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                            <li class="mobile-menu__group-item list-item jsGroupItem">
                                <button class="mobile-menu__label jsMenuButtonNav" role="button">
                                    <span class="mobile-menu__nav-link">Andet</span>
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                </button>
                                <ul class="mobile-menu__links list" data-level="2">
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/driftsinformation"  >
                                            Tjek driftsinformation
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/hastighedstest"  >
                                            Tjek hastighedstest
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                    <li class="mobile-menu__link-item list-item">
                                        <a class="mobile-menu__link" href="https://yousee.dk/hjaelp/butik"  >
                                            Find YouSee Butik
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                                        </a>
                                    </li>
                                </ul>
                                <nav class="header__shortcuts">
                                    <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                        <span class="header__shortcut-name">Find mere hjælp</span>
                                        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                        </svg>
                                    </a>
                                </nav>

                            </li>
                        </ul>

                        <nav class="header__shortcuts">
                            <a href="https://yousee.dk/hjaelp"  class="header__shortcut">
                                <span class="header__shortcut-name">Find mere hjælp</span>
                                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.02813 4.12292L1.72813 0.23125C1.38647 -0.0770833 0.844801 -0.0770833 0.503135 0.23125C0.161468 0.539583 0.169801 1.05625 0.503135 1.36458L4.20313 4.68958L0.503134 8.01458C0.169801 8.33125 0.169801 8.83958 0.503134 9.14792C0.836468 9.46458 1.38647 9.46458 1.7198 9.14792L6.02813 5.25625C6.36147 4.93958 6.36147 4.43125 6.02813 4.12292Z" fill="black" fill-opacity="0.87"/>
                                </svg>
                            </a>
                        </nav>

                    </li>

                    <li class="mobile-menu__item list-item jsMenuItem">
                        <a class="mobile-menu__link"  href="https://selvbetjening.yousee.dk" >
                            Mit YouSee
<svg class="mobile-menu__label_arrow" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.31635 1.22645C9.64195 0.901174 10.1696 0.90144 10.4949 1.22704L15.6461 6.38343C15.8001 6.5237 15.9014 6.72095 15.9165 6.94186C15.933 7.17431 15.8524 7.41236 15.6748 7.59014L10.4949 12.7753C10.1696 13.1009 9.64195 13.1012 9.31635 12.7759C8.99075 12.4507 8.99048 11.923 9.31576 11.5974L13.0763 7.83307H1.01109C0.550848 7.83307 0.177752 7.45998 0.177752 6.99974C0.177752 6.5395 0.550848 6.16641 1.01109 6.16641H13.0734L9.31576 2.40496C8.99048 2.07936 8.99075 1.55172 9.31635 1.22645Z" fill="black" fill-opacity="0.87"/>
</svg>
                        </a>

                    </li>
                </ul>
        </nav>
    </div>

    <div class="mobile-menu__bottom">
    <nav class="header__bottom-links" id="headerBottomLinks">
        <a href="https://musik.yousee.dk"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/4lE3xiTy5SaqcgxndvP7vu/dea31726d76a6f392483c4d2cea7e4ec/music-dark.svg alt="YouSee Musik" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">YouSee Musik</span>
        </a>
        <a href="https://play.yousee.dk"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/74yySyMd4CeTmzqhyCZKpz/0145a3e7beb930d0929b392cd1edca0c/play_mobile_bottom_link.svg alt="YouSee Play" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">YouSee Play</span>
        </a>
        <a href="https://profil.yousee.dk/?context=mail"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/1H1YFitiwcX9cuyH0vEwdV/fb0fc313aa4213ece3653adc3b5a48ac/mail_icon_mobile_bottom_link.svg alt="Webmail" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Webmail</span>
        </a>
        <a href="https://yousee.dk/hjaelp/kontakt"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/6bKZUeJxeiSaPDGTOb1Ek9/1a9a2e2306c6ff9474264a550d0719e5/IconButton.svg alt="Kontakt os" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Kontakt os</span>
        </a>
        <a href="https://yousee.dk/hjaelp/butik"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/6bKZUeJxeiSaPDGTOb1Ek9/1a9a2e2306c6ff9474264a550d0719e5/IconButton.svg alt="Find YouSee butik" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Find YouSee butik</span>
        </a>
        <a href="https://yousee.dk/hjaelp/driftsinformation"  class="header__bottom-link">
            <figure class="header__bottom-link-icon-container">
                <img src=//images.ctfassets.net/qn2mzafc6iit/4lE3xiTy5SaqcgxndvP7vu/dea31726d76a6f392483c4d2cea7e4ec/music-dark.svg alt="Driftsinformation" class="header__bottom-link-icon" />
            </figure>
            <span class="header__bottom-link-name">Driftsinformation</span>
        </a>
    </nav>
    </div>
</div>


<script>
    (() => {
        const ACTIVE_MODIFIER = "_active";
        const ACTIVE_MENU = "_active-nav-menu";
        const HIDDEN = "_hidden";
        const VISIBLE = "_visible";

        const isHomePage = window.portal?.isHomePage;
        const isWebView = window.portal?.isWebView;
        const isShoppingCartPage = window.portal?.isShoppingCartPage;
        const isEcare = window.portal?.isEcarePage;

        const popoverElement = document.querySelector('.jsMobileMenuPopover');
        const menuButtonElement = document.querySelector('.jsMenuButtonOpen');
        const closeButtonElement = document.querySelector('.jsMenuButtonClose');
        const itemsElements = document.querySelectorAll('.jsMenuButtonNav');
        const buttonGoBackElement = document.querySelectorAll('.jsMenuButtonBack');
        const ecareMenuWrapperElement = document.getElementById('ecareMenuWrapper');
        const headerBottomLinksElement = document.getElementById('headerBottomLinks');
        const mobileMenuSearchElement = document.querySelector('.jsMobileMenuSearch');
        const mobileMenuSearchInputElement = document.querySelector('.jsMobileMenuSearchInput');
        const ecareButtonGoBackElement = document.getElementById('jsEcareNavMenuButtonBack');
        const mobileMenuElement = document.querySelector('.jsNavMenu');
        const ecareMenuElement = document.querySelector('.jsEcareNavMenu');
        const middleMenuElement = document.querySelector('.jsMiddleMenu');
        const shopTitleElement = document.querySelector('.jsShopTitle');
        const headerButtonGoBackElement = document.querySelector('.jsHeaderButtonGoBack');
        const mobileSearchCloseElement = document.querySelector('.jsMobileSearchClose');
        const searchMobileSuggestionsElement = document.querySelector('.jsSearchMobileSuggestions');
        const authButtonElement = document.querySelector('.jsAuthIcon');

        const setMobileSearchSuggestions = (suggestionsResponse) => {
            searchMobileSuggestionsElement.innerHTML = '';

            window.SearchService.suggestions.forEach((value) => {
                const suggestionElement = window.SearchService.createSearchSuggestionElement(value);
                searchMobileSuggestionsElement.appendChild(suggestionElement);
            });
        }

        const closeMobileSearch = () => {
            middleMenuElement.classList.remove('_active-search');
            mobileMenuSearchElement?.classList.add('_empty');

            if (mobileMenuSearchInputElement) mobileMenuSearchInputElement.value = '';
            window.SearchService.setSuggestions([]);
            if (searchMobileSuggestionsElement) searchMobileSuggestionsElement.innerHTML = '';
            popoverElement.removeEventListener('click', onMobileMenuSearchClick);
        }

        const onMobileMenuSearchClick = (event) => {
            const searchContainerElement = event.target.closest('.jsMobileMenuSearch');

            if (!searchContainerElement) {
                closeMobileSearch();
            }
        };


        function onMobileSearchInput() {
            debounce(() => {
                if(mobileMenuSearchInputElement.value.length) {
                    mobileMenuSearchElement.classList.remove('_empty');
                    const searchValue = mobileMenuSearchInputElement.value;
                    window.SearchService.requestSearchSuggestions(searchValue).then(suggestionsResponse => {
                        setMobileSearchSuggestions(suggestionsResponse);
                    });
                } else {
                    mobileMenuSearchElement.classList.add('_empty');
                    window.SearchService.setSuggestions([]);
                    searchMobileSuggestionsElement.innerHTML = '';
                }
            })();
        }

        function onMobileSearchKeyDown(event) {
            if(event.key === 'Enter') {
                const searchParams = window.SearchService.getSearchParams(mobileMenuSearchInputElement.value);
                location.href = window.SearchService.searchPageUrl + searchParams.toString();
            }
        }


        Array.from(itemsElements).forEach((e) => {
            e.addEventListener("click", function () {
                this.parentNode.classList.add(ACTIVE_MODIFIER);
                addActiveLevelAttribute(this.closest('.list').dataset.level);
                middleMenuElement.classList.add(ACTIVE_MENU);
            });
        });

        Array.from(buttonGoBackElement).forEach((e) => {
            e.addEventListener("click", function () {
                if(e.classList.contains('go-back-to-1'))  {
                    addActiveLevelAttribute("0");
                    document.querySelector('.jsMenuItem._active').classList.remove(ACTIVE_MODIFIER);
                    middleMenuElement.classList.remove(ACTIVE_MENU);
                } else if(e.classList.contains('go-back-to-2')) {
                    addActiveLevelAttribute("1");
                    document.querySelector('.jsGroupItem._active').classList.remove(ACTIVE_MODIFIER);
                } else {
                    closeMenu();
                }
            });
        });

        if (ecareButtonGoBackElement) {
            ecareButtonGoBackElement.addEventListener("click", () => {
                middleMenuElement.classList.remove(ACTIVE_MENU);
                ecareMenuWrapperElement.setAttribute("style", "display:none");
                toggleMenuBar(false);
                mobileMenuElement.classList.remove(HIDDEN);
            });
        }

        window.addEventListener("ecare_initialized", () => {
            ecareMenuWrapperElement.setAttribute("style", "display:block");
            ecareMenuElement.classList.remove(HIDDEN);
            mobileMenuElement.classList.add(HIDDEN);
        })

        window.addEventListener("ecare_destroyed", () => {
            ecareMenuWrapperElement.setAttribute("style", "display:none");
            mobileMenuSearchElement?.setAttribute("style", "display: none");
            headerBottomLinksElement?.setAttribute("style", "display: none");
            ecareMenuElement.classList.add(HIDDEN);
            mobileMenuElement.classList.remove(HIDDEN);
        })

        function toggleMenuBar(ecareMobileView) {
            if (ecareMobileView) {
                mobileMenuSearchElement?.setAttribute("style", "display: none");
                headerBottomLinksElement?.setAttribute("style", "display: none");
                ecareButtonGoBackElement.setAttribute("style", "display: flex");
            } else {
                mobileMenuSearchElement?.setAttribute("style", "display: flex");
                headerBottomLinksElement?.setAttribute("style", "display: flex");
                ecareButtonGoBackElement.setAttribute("style", "display: none");
            }
        }

        function closeMenuBar() {
            mobileMenuSearchElement?.setAttribute("style", "display: none");
            headerBottomLinksElement?.setAttribute("style", "display: none");
            ecareButtonGoBackElement.setAttribute("style", "display: none");
        }

        function addActiveLevelAttribute(level) {
            middleMenuElement.dataset.activeLevel = level;
        }

        menuButtonElement?.addEventListener('click', () => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + "px";
            if (isEcare) {
                middleMenuElement.classList.add(ACTIVE_MENU);
                if (!ecareMenuElement.classList.contains(HIDDEN)) {
                    mobileMenuElement.classList.add(HIDDEN);
                }
            }
            toggleMenuBar(isEcare);
            closeButtonElement.classList.remove(HIDDEN);
            menuButtonElement.classList.add(HIDDEN);
            popoverElement.classList.add(VISIBLE);
            middleMenuElement.style.paddingRight = scrollbarWidth;
            popoverElement.style.paddingRight = scrollbarWidth;
            document.body.style.overflow = "hidden";
            if (isWebView) {
                isHomePage && shopTitleElement.classList.add(HIDDEN);
                headerButtonGoBackElement.classList.remove(HIDDEN);
            }
        })

        authButtonElement?.addEventListener('click', () => {
            if (document.body.clientWidth <= 767.999) {
                menuButtonElement.classList.add(HIDDEN);
                closeButtonElement.classList.remove(HIDDEN);
            }
        })

        closeButtonElement.addEventListener('click', function() {
            if (isWebView && isShoppingCartPage) {
                history.back();
            } else {
                closeMenu();
            }
        })

        window.addEventListener("resize", function(){
            if(document.body.clientWidth >= 1024){
                closeMenu();
            }
        });

        isWebView && headerButtonGoBackElement.addEventListener('click', () => {
            const middleMenuEl = document.querySelector('.jsMiddleMenu');
            const activeLevel = middleMenuEl.dataset.activeLevel - 1;
            const middleMenuMap = [
                document.querySelector('.jsMenuItem._active'),
                document.querySelector('.jsGroupItem._active')
            ];
            if (middleMenuMap[activeLevel]) {
                middleMenuMap[activeLevel].classList.remove(ACTIVE_MODIFIER);
                addActiveLevelAttribute(String(activeLevel));
                return;
            }
            if (popoverElement.classList.contains(VISIBLE)) {
                closeMenu();
            } else {
                history.back();
            }
        });

        function closeMenu() {
            closeButtonElement.classList.add(HIDDEN);
            menuButtonElement.classList.remove(HIDDEN);
            popoverElement.classList.remove(VISIBLE);
            middleMenuElement.classList.remove(ACTIVE_MENU);
            addActiveLevelAttribute("0");
            document.body.style.removeProperty("overflow");
            middleMenuElement.style.removeProperty('padding-right');
            popoverElement.style.removeProperty('padding-right');

            if (isWebView && isHomePage) {
                shopTitleElement.classList.remove(HIDDEN);
                headerButtonGoBackElement.classList.add(HIDDEN);
            }

            itemsElements.forEach((label) => {
                label.parentElement.classList.remove(ACTIVE_MODIFIER);
            });

            if (isEcare) {
                middleMenuElement.classList.remove(ACTIVE_MENU);
                ecareMenuWrapperElement.setAttribute("style", "display:block");
                closeMenuBar();
            }

            closeMobileSearch();
        }

        if (mobileMenuSearchInputElement) {
            mobileMenuSearchInputElement.addEventListener('focus', () => {
                middleMenuElement.classList.add('_active-search');
                popoverElement.addEventListener('click', onMobileMenuSearchClick);
            });

            mobileMenuSearchInputElement.addEventListener('input', onMobileSearchInput);
            mobileMenuSearchInputElement.addEventListener('keydown', onMobileSearchKeyDown);
            mobileSearchCloseElement.addEventListener('click', closeMobileSearch);
        }
    })();
</script>
                        </div>
                    </div>
                </div>
        </div>
            <div class="nd-header__search jsHeaderSearch">
            <div class="search__field-container page-limiter">
                <div class="search__field-container-inner jsSearchContainer">
                    <div class="search__suggestions-container">
                        <div class="search__suggestions jsSearchSuggestions"></div>
                    </div>
                    <div class="search__field-components">
                        <label class="search__field jsSearchField">
                            <input type="text"
                                class="search__input jsSearchInput"
                                placeholder="Søg"
                            />
                            <button type="button"
                                class="search__field-icon _cross jsSearchClose"
                                role="button"
                            >
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.675 10.0042L16.3 5.38753C16.625 5.06253 16.625 4.53753 16.3 4.21253C15.975 3.88753 15.45 3.88753 15.125 4.21253L10.5 8.8292L5.88338 4.2042C5.55838 3.8792 5.02505 3.8792 4.70005 4.2042C4.37505 4.5292 4.37505 5.06253 4.70005 5.38753L9.32505 10.0042L4.70005 14.6209C4.37505 14.9459 4.37505 15.4709 4.70005 15.7959C5.02505 16.1209 5.55005 16.1209 5.87505 15.7959L10.4917 11.1792L15.1084 15.7959C15.4334 16.1209 15.9584 16.1209 16.2834 15.7959C16.6084 15.4709 16.6084 14.9459 16.2834 14.6209L11.6667 10.0042H11.675Z" fill="black" fill-opacity="0.6"/>
                                </svg>
                            </button>
                            <span class="search__field-icon-separator"></span>
                        </label>

                        <button type="button"
                            class="search__field-icon _search jsSearchFieldIcon"
                            tabindex="-1"
                            role="button">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1951 18.3071L16.0851 14.2071C16.9651 13.0371 17.4951 11.5871 17.4951 10.0171C17.4851 6.14709 14.3551 3.01709 10.4851 3.01709C6.61511 3.01709 3.48511 6.14709 3.48511 10.0171C3.48511 13.8871 6.61511 17.0171 10.4851 17.0171C12.0551 17.0171 13.4951 16.4971 14.6651 15.6271L18.7751 19.7271C19.1651 20.1171 19.7951 20.1171 20.1851 19.7271C20.5751 19.3371 20.5751 18.7071 20.1851 18.3171L20.1951 18.3071ZM10.4851 14.8571C7.80511 14.8571 5.63511 12.6871 5.63511 10.0071C5.63511 7.32709 7.80511 5.16709 10.4851 5.16709C13.1651 5.16709 15.3351 7.33709 15.3351 10.0171C15.3351 12.6971 13.1651 14.8671 10.4851 14.8671V14.8571Z" fill="black" fill-opacity="0.6"/>
                            </svg>
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<script>
    const popupWrapperClass = '.jsPopup';
    const userButtonClass = '.jsUserButton';
    const popupWrapperSelector = document.querySelector(popupWrapperClass);
    const userButtonSelector = document.querySelector(userButtonClass);
    const logInButtonSelector = document.querySelector('.jsLogInButton');
    const logOutButtonSelector = document.querySelector('.jsLogOutButton');
    const OPENED_MODIFIER = '_opened';

    function visibilityPopup() {
        popupWrapperSelector.classList.toggle(
            OPENED_MODIFIER,
            !popupWrapperSelector.classList.contains(OPENED_MODIFIER)
        );
        resize();
    }

    function resize() {
        if (popupWrapperSelector.classList.contains(OPENED_MODIFIER)) {
            const position = userButtonSelector.getBoundingClientRect();
            if (window.innerWidth < 767) {
                popupWrapperSelector.style.right = '0px';
            } else {
                popupWrapperSelector.style.right = (window.innerWidth - position.right).toFixed() + 'px';
            }
        }
    }

    function closePopup(event) {
        const isClosest = event.target.closest(popupWrapperClass) || event.target.closest(userButtonClass)
        if (!isClosest && popupWrapperSelector.classList.contains(OPENED_MODIFIER))
            popupWrapperSelector.classList.remove(OPENED_MODIFIER)
    }


    let logOutListeners = []
    let logInListeners = []

    window.sharedNavigation = {
        addLogInListener: (listener) => logInListeners.push(listener),
        removeLogInListener: (listener) => logInListeners = logInListeners.filter(value => value !== listener),

        addLogOutListener: (listener) => logOutListeners.push(listener),
        removeLogOutListener: (listener) => logOutListeners = logOutListeners.filter(value => value !== listener),

        setUserInfo: ((userInfo) => {
            if (!!userInfo) {

                const privateInformation = document.querySelector(".jsPrivateInformation");
                if (!!userInfo.firstName) {
                    privateInformation.querySelector('.jsFirstName').textContent = userInfo.firstName;
                }
                if (!!userInfo.lastName) {
                    privateInformation.querySelector('.jsLastName').textContent = userInfo.lastName;
                }
                if (!!userInfo.firstName && !!userInfo.lastName) {
                    document.querySelectorAll('.jsAvatar').forEach((avatar) => avatar.textContent =
                        (userInfo.firstName[0] + userInfo.lastName[0]).toUpperCase());
                }
                userButtonSelector.hidden = false;
                logInButtonSelector.hidden = true;
            } else {
                popupWrapperSelector.classList.remove('_opened');
                userButtonSelector.hidden = true;
                logInButtonSelector.hidden = false;
            }
        }),
    }

    function logOut() {
        logOutListeners.forEach(listener => listener())
    }

    function logIn() {
        logInListeners.forEach(listener => listener())
    }

    document.addEventListener('click', closePopup);
    window.addEventListener('resize', resize);

    userButtonSelector.addEventListener('click', visibilityPopup);
    logInButtonSelector.addEventListener('click', logIn);
    logOutButtonSelector.addEventListener('click', logOut);
</script>
<script>
    (function() {
        const menuItems = document.querySelectorAll('.jsNavMenuItem');

        const removeLeaveForItems = debounce(function() {
            menuItems.forEach(function(item) {
                item.classList.remove("_leaving");
            });
        }, 500);

        menuItems.forEach(function(menuItem) {
            menuItem.addEventListener('mouseover', openHoveredOrFocusedMenuItemAndCloseOther);
            menuItem.querySelector('.jsNavMenuLabel').addEventListener('focus', openHoveredOrFocusedMenuItemAndCloseOther);

            menuItem.addEventListener('mouseleave', function(){
                menuItem.classList.add("_leaving");
                menuItem.classList.remove("_hover");
                removeLeaveForItems();
            });

            ['a.jsNavMenuLabel', 'button.jsNavMenuLabel'].forEach(function(selector) {
                menuItem
                    .querySelectorAll(selector)
                    .forEach(addMainMenuNavigationListener);
            });

            function openHoveredOrFocusedMenuItemAndCloseOther() {
                removeHoverForAllItems();
                menuItem.classList.add('_hover');
            }

            function addMainMenuNavigationListener(element) {
                element.addEventListener('keydown', triggerMainMenuNavigation);
            }
        });

        function triggerMainMenuNavigation(event) {
            if (event.key === 'Tab') {
                const currentElement = event.target;
                const currentTopLevelMenuItemWrapper = currentElement.closest('.jsNavMenuItem');
                const previousTopLevelMenuItemWrapper = currentTopLevelMenuItemWrapper.previousElementSibling;
                const nextTopLevelMenuItemWrapper = currentTopLevelMenuItemWrapper.nextElementSibling;
                const menuItemHasDropdown = currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('nav-menu__item-container');
                const firstLinkInDropdown = menuItemHasDropdown && currentElement.nextElementSibling.querySelector('.jsNavMenuLink');

                // reverse navigation
                if (event.shiftKey) {
                    if (previousTopLevelMenuItemWrapper) {
                        // switch focus to previous top level menu item
                        previousTopLevelMenuItemWrapper.querySelector('.jsNavMenuLabel').focus();
                    } else {
                        // switch focus to logo
                        removeHoverForAllItems();
                        document.querySelector('.jsNavLogoLink').focus();
                    }
                } else {
                    if (menuItemHasDropdown && firstLinkInDropdown) {
                        // we need to go deeper if there is dropdown with links
                        firstLinkInDropdown.focus();
                    } else if (nextTopLevelMenuItemWrapper) {
                        // switch focus to next top menu element
                        nextTopLevelMenuItemWrapper.querySelector('.jsNavMenuLabel').focus();
                    } else {
                        // switch focus to search
                        removeHoverForAllItems();
                        document.querySelector('.jsSearchOpen').focus();
                    }
                }

                event.preventDefault();
                return false;
            }
        }

        function removeHoverForAllItems() {
            menuItems.forEach(function(item) {
                item.classList.remove("_hover");
                item.classList.remove("_leaving");
            });
        }
    })();
</script>
<script>
        class SearchService {
            suggestions;
            siteKey;
            autocompleteUrl;
            searchPageUrl;
            inputType;

            constructor () {
                this.suggestions = [];
                this.siteKey = "MjA1MzoxMDExMzpTZWFyY2hLZXk=";
                this.autocompleteUrl = "https://api.cludo.com/api/v3/2053/10113/autocomplete";
                this.searchPageUrl = "https://yousee.dk/soeg?#?";
                this.inputType = "standard";
            }

            setSuggestions = (suggestions) => {
                this.suggestions = suggestions;
            }

            createSearchSuggestionElement = (searchValue) => {
                const searchParams = this.getSearchParams(searchValue);
                const suggestionElement = document.createElement('a');
                suggestionElement.setAttribute('href', this.searchPageUrl + searchParams.toString());
                suggestionElement.classList.add('search__suggestion');
                suggestionElement.innerText = searchValue;
                return suggestionElement;
            }

            getSearchParams(searchValue) {
                const params = {
                    cludoquery: searchValue,
                    cludoinputtype: this.inputType,
                    cludopage: 1,
                    cludorefurl: location.href,
                    cludorefpt: document.title
                }

                return Object.entries(params).map(param => param.map(encodeURIComponent).join("=")).join("&");
            }

            requestSearchSuggestions = async (searchValue) => {
                this.suggestions = [];

                const url = new URL(this.autocompleteUrl);
                url.searchParams.append("query", searchValue);
                url.searchParams.append("responsetype", this.inputType);
                url.searchParams.append("results", 10);

                const autocompleteResponse = await fetch(url, {
                    headers: {
                        "Content-type": "application/json",
                        'Authorization':  'SiteKey '+ this.siteKey
                    }
                });
                const suggestionsResponse = await autocompleteResponse.json();
                this.setSuggestions(suggestionsResponse);

                return Promise.resolve(suggestionsResponse);
            }
        }

        window.SearchService = new SearchService();
</script>
<script>
    (function() {
        // Elements
        const searchFieldElement = document.querySelector(".jsSearchField");
        const searchFieldIconElement = document.querySelector(".jsSearchFieldIcon");
        const headerSearchElement = document.querySelector(".jsHeaderSearch");
        const searchInputElement = document.querySelector(".jsSearchInput");
        const searchSuggestionsElement = document.querySelector(".jsSearchSuggestions");
        const searchCloseElement = document.querySelector(".jsSearchClose");
        const searchOpenElement = document.querySelector(".jsSearchOpen");

        // Event Listeners
        searchInputElement.addEventListener('keydown', onSearchKeyDown);
        searchCloseElement.addEventListener('click', onSearchClose);
        searchCloseElement.addEventListener('keydown', onSearchCrossKeydown);
        searchSuggestionsElement.addEventListener('keydown', onSearchSuggestionsKeydown);
        searchOpenElement.addEventListener('click', onSearchOpen);

        // State Variables
        let focusedSuggestionIndex = -1;

        window.addEventListener("scroll", function() {
            if (searchFieldElement.classList.contains('_opened')) {
                onSearchClose();
            }
        });

        window.addEventListener("resize", function() {
            if (searchFieldElement.classList.contains('_opened')) {
                onSearchClose();
            }
        });

        function onWindowClick(event) {
            const searchContainerElement = event.target.closest('.jsSearchContainer');
            if (!searchContainerElement) {
                onSearchClose();
            }
        }

        function onSearchOpen() {
            headerSearchElement.style.display = 'block';
            setTimeout(() => {
                searchFieldElement.classList.add('_opened');
                searchFieldIconElement.style.display = 'flex';
                setSearchFocus();
                window.addEventListener("click", onWindowClick);
            });
        }

        function onSearchClose() {
            searchFieldElement.classList.remove('_opened');
            searchSuggestionsElement.innerHTML = '';
            window.SearchService.setSuggestions([]);
            focusedSuggestionIndex = -1;

            setTimeout(() => {
                searchFieldIconElement.style.display = 'none';
                headerSearchElement.style.display = 'none';
                searchInputElement.value = '';
                window.removeEventListener("click", onWindowClick);
            }, 400);
        }

        function setSearchFocus() {
            setTimeout(() => {
                searchInputElement.focus();
            }, 400);
        }

        function setSearchSuggestions(suggestionsResponse) {
            if (searchFieldElement.classList.contains('_opened')) {
                searchSuggestionsElement.innerHTML = '';

                window.SearchService.suggestions.forEach((value) => {
                    const suggestionElement = window.SearchService.createSearchSuggestionElement(value);
                    searchSuggestionsElement.appendChild(suggestionElement);
                });
            }
        }

        const fetchSuggestions = debounce(() => {
            if (searchInputElement.value) {
                window.SearchService.requestSearchSuggestions(searchInputElement.value).then(suggestionsResponse => {
                    setSearchSuggestions(suggestionsResponse);
                });
            } else {
                window.SearchService.setSuggestions([]);
                setSearchSuggestions([]);
            }
        }, 500);

        function onSearchKeyDown(event) {
            requestAnimationFrame(function() {
                switch (event.key) {
                    case 'ArrowDown':
                        if (window.SearchService.suggestions.length) {
                            focusedSuggestionIndex = 0;
                            searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                        }
                        break;
                    case 'ArrowUp':
                        if (window.SearchService.suggestions.length) {
                            focusedSuggestionIndex = window.SearchService.suggestions.length - 1;
                            searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                        }
                        break;
                    case 'Enter':
                        const searchParams = window.SearchService.getSearchParams(searchInputElement.value);
                        location.href = window.SearchService.searchPageUrl + searchParams.toString();
                        break;
                    default:
                        fetchSuggestions();
                        break;
                }
            });
        }

        function onSearchCrossKeydown(event) {
            switch (event.key) {
                case 'ArrowDown':
                    if (window.SearchService.suggestions.length) {
                        focusedSuggestionIndex = 0;
                        searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    }
                    break;
                case 'ArrowUp':
                    if (window.SearchService.suggestions.length) {
                        focusedSuggestionIndex = window.SearchService.suggestions.length - 1;
                        searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    }
                    break;
                case 'ArrowLeft':
                    searchInputElement.focus();
                    break;
                case 'Tab':
                    onSearchClose();
                    break;
            }
        }

        function onSearchSuggestionsKeydown(event) {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    focusedSuggestionIndex = focusedSuggestionIndex === window.SearchService.suggestions.length - 1 ? 0 : focusedSuggestionIndex + 1;
                    searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    focusedSuggestionIndex = focusedSuggestionIndex === 0 ? window.SearchService.suggestions.length - 1 : focusedSuggestionIndex - 1;
                    searchSuggestionsElement.children[focusedSuggestionIndex].focus();
                    break;
                case 'Tab':
                    focusedSuggestionIndex = -1;
                    break;
            }
        }
    })();
</script>
<script>
    // header styles
    (function() {
        let firstRender = true;
        const headerResizeObserver = new ResizeObserver(function(entries) {
            document.documentElement.style.setProperty('--nd-total-header-height', entries[0]?.contentRect.height + 'px');

            if (firstRender) {
                firstRender = false;
                document.querySelector('.default-body')?.classList.add('_no-animation');

                setTimeout(() => {
                    document.querySelector('.default-body')?.classList.remove('_no-animation');
                })
            }
        });

        headerResizeObserver.observe(document.querySelector('.nd-header'));
    })();

    (function() {
        const bodyMutationObserver = new MutationObserver(function(mutations) {
            const header = document.querySelector('.nd-header');
            mutations.forEach(function(mutation) {
                if(mutation.attributeName === 'style'){
                    if (mutation.target.style.overflow === "hidden"){
                        header.style.paddingRight = mutation.target.style.paddingRight;
                    } else {
                        header.style.removeProperty("overflow");
                        header.style.removeProperty("padding-right");
                    }
                }
            });
        });

        bodyMutationObserver.observe(document.body, {
            attributes: true,
            attributeFilter: [ 'style' ]
        });
    })();

    // set header top line size
    (function() {
        const topHeaderResizeObserver = new ResizeObserver(function(entries) {
            document.documentElement.style.setProperty('--nd-header-top-height', entries[0]?.contentRect.height + 'px');
        });
        topHeaderResizeObserver.observe(document.querySelector('.nd-header__top'));
    })();

    // hide or show top line
    (function() {
        window.addEventListener("scroll", function() {
            const headerTop = document.querySelector('.nd-header');
            const heightHeaderTop = parseInt(document.documentElement.style.getPropertyValue('--nd-header-top-height'));

            if (headerTop) {
                if (
                    document.body.scrollTop > heightHeaderTop
                    || document.documentElement.scrollTop > heightHeaderTop
                ) {
                    document.body.classList.add("_hiddenHeaderTop");
                } else {
                    document.body.classList.remove("_hiddenHeaderTop");
                }
            }
        });
    })();
</script>
`;
